import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-tailwind/react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import { Provider } from "react-redux";

// Suppress harmless ResizeObserver loop errors triggered by Monaco editor DOM resizes
window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded" ||
    (e.message && e.message.includes("ResizeObserver"))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const rootElement = document.getElementById("root");

// If this is an SPA route fallback, wipe any stale pre-rendered HTML before React mounts
if (document.documentElement.classList.contains("is-spa-route")) {
  rootElement.innerHTML = "";
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);
// Clean up pre-paint route gate once React has started rendering
requestAnimationFrame(() => {
  document.documentElement.classList.remove("is-spa-route");
  const loader = document.getElementById("spa-pre-paint-loader");
  if (loader) loader.remove();
});

reportWebVitals();
